import { JSX } from 'react';
import StyledPromptFooter from '../../styles/StyledPromptFooter';

interface PromptFooterProps {
  whiteLabeled?: boolean;
}

const PromptFooter = ({ whiteLabeled = false }: PromptFooterProps): JSX.Element => {
  return (
    <StyledPromptFooter>
      { whiteLabeled ?
        ''
      : <a className='dcinnovation' href='https://www.elora.lu/' target='_blank' rel="noreferrer">Made by Elora • </a>}
      <b><a href='https://www.elora.lu/disclaimer' target='_blank' rel="noreferrer">Disclaimer</a></b>
    </StyledPromptFooter>
  );
};

export default PromptFooter;
